<mat-toolbar-row class="top-bar-nav">
  <button mat-icon-button (click)="sidenav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="navbar-header">
    <div class="navbar-brand">
      <!--<img
      alt="homepage"
      class="light-logo small-logo"
      src="assets/images/pentland_logo-white.png"/>-->
      <div *ngIf="brandLogo" class="app-brand-logo">
        <img [src]="acushnetLogo" />
      </div>
      <div *ngIf="!brandLogo" class="app-brand-logo">
        <img
          alt="homepage"
          class="light-logo small-logo"
          src="assets/images/no-image.png"
        />
      </div>
      <div class="app-other-brands">
        <img [src]="titleistLogo" />
        <img [src]="footjoyLogo" />
        <img [src]="scottyLogo" />
        <img [src]="vokeyLogo" />
        <img [src]="linksandkingsLogo" />
        <img [src]="clubgloveLogo" />
      </div>
      <!-- <span><img
          alt="homepage"
          class="light-logo small-logo"
          src="assets/images/no-image.png" />
          </span> -->
    </div>
  </div>

  <div class="top-bar-actions">
    <button mat-icon-button (click)="onLogout()">
      <mat-icon>logout</mat-icon>
    </button>
    <button mat-icon-button [routerLink]="[profileRoute]">
      <img
        [src]="
          user &&
          user.profileImage != 'null' &&
          user.profileImagePath &&
          !isRequestStart
            ? user.profileImagePath
            : defaultPath
        "
        alt="user"
        class="profile-pic"
        onError="this.src='assets/images/Profile.png'"
      />
    </button>

    <button
      class="float-right"
      mat-icon-button
      [matMenuTriggerFor]="menulanguage"
    >
      <mat-icon>language</mat-icon>
    </button>
    <mat-menu #menulanguage="matMenu" class="text-center">
      <div class="languages-dropdown">
        <ul>
          <li (click)="onChangeLanguage('en-US')">
            <a>US-English</a>
          </li>
          <li (click)="onChangeLanguage('en-CA')">
            <a>CA-English</a>
          </li>
          <li (click)="onChangeLanguage('fr-CA')">
            <a>CA-French</a>
          </li>
        </ul>
      </div>
    </mat-menu>
  </div>
</mat-toolbar-row>
